import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LayoutComponent } from '@ng-cds/ui-components/layout';
import { HeaderComponent } from '@ng-cds/ui-components/header';
import { LeftMenuComponent } from '../../components/left-menu/left-menu.component';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { RuleDetailsApiService } from '@vallia-doc-flow-ui/common';
import { Subject, Subscription, takeUntil, tap, timer } from 'rxjs';
import { AuthService, FeatureFlagService } from '@vallia-doc-flow/ui-auth';
import { shouldCheckUnderwriterCondition, shouldCheckUnderwriterUrl } from '../../components/left-menu/menu.utils';

interface UserDetails {
  applicationId: string;
  applicationName: string;
  clientId: string;
  email: string;
  isActive: boolean;
  role: string;
  tenantId: number;
  userId: string;
  userName: string;
}
@Component({
  selector: 'vallia-doc-flow-layout-page',
  templateUrl: './layout-page.component.html',
  styleUrl: './layout-page.component.scss',
  standalone: true,
  imports: [LayoutComponent, HeaderComponent, LeftMenuComponent, RouterOutlet, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutPageComponent implements OnInit {
  userName!: string;
  emailId!: string;
  userDetails!: UserDetails;

  private router = inject(Router);
  private authService = inject(AuthService);
  public ruleDetailsApiService = inject(RuleDetailsApiService);
  refreshToken!: string;
  timerSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>();
  private featureService = inject(FeatureFlagService);

  ngOnInit(): void {
    const sessionValue = sessionStorage.getItem('userDetails');
    if (sessionValue) {
      const userDetails: UserDetails = JSON.parse(sessionValue);
      if (userDetails) {
        this.userName = userDetails.userName;
        this.emailId = userDetails.email;
      }
    }
    this.authService.refreshToken.subscribe(res => {
      this.refreshToken = res;
    });
    // calling refresh token api only if there is a refresh token
    if (this.refreshToken) {
      if (this.timerSubscription) {
        return;
      }
      this.timerSubscription = timer(0, 840000) // every 14minutes
        .pipe(
          tap(() => {
            this.authService.getRefreshToken().subscribe(res => {
              this.authService.refreshToken.next(res.access_token);
              sessionStorage.setItem('authToken', res.access_token);
            });
          }),
          takeUntil(this.destroy$)
        )
        .subscribe();
    }
  }

  shouldCheckUnderwriterCondition(): boolean {
    return shouldCheckUnderwriterCondition(this.featureService);
  }

  shouldCheckUnderwriterUrl(): boolean {
    return shouldCheckUnderwriterUrl();
  }

  logout(): void {
    this.destroy$.next();
    this.destroy$.complete();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  getFeedbackWidget(): void {
    const feedbacklabel = document.getElementById('feedbacklabel') as HTMLButtonElement;
    if (feedbacklabel) {
      feedbacklabel.click();
      this.modalHeaderChange();
    }
  }
  modalHeaderChange(): void {
    const titleElement = document.querySelector('.zstitlemini');
    if (titleElement) {
      titleElement.textContent = 'Vallia DocFlow';
    }
    const nameElement = document.querySelector<HTMLInputElement>(
      '.feedbackformmdiv .WF_NameEmailDiv .fbtxtnf#feedbNameTxtField'
    );
    if (nameElement) {
      nameElement.value = this.userName;
    }
    const emailElement = document.querySelector<HTMLInputElement>(
      '.feedbackformmdiv .WF_NameEmailDiv .fbtxtnf#feedbEmailTxtField'
    );
    if (emailElement) {
      emailElement.value = this.emailId;
    }
  }
}
